module.exports = __webpack_public_path__ + "media/images/help/flow/pill-2months-4e0b15f4f22ec99d8ae7f26ca82ee1c6.svg";